import React from "react";
import { Button, Col} from "react-bootstrap";
import PropTypes from 'prop-types';
import { useModal } from '../../../hooks/useModal';
import HelperMetiers360 from '../../../services/HelpersMetiers360.js';


const FileModalComponent = ({ files, editFilesModal, modalHeaderTitle, dialogClassName }) => {


    const { modalComponent, setModalShow, modalData, setModalData } = useModal();

    const openFileModal = () => {
        var title;
        if (modalHeaderTitle) {
            title = modalHeaderTitle;
        } else {
            title = files?.length > 1 ? "Fichiers liés" : "Fichier lié";
        }
        setModalData({
            ...modalData,
            header: <>{title}</>,
            content: <>{filesModalContent}</>,
            size: dialogClassName ? null : "lg",
            dialogClassName: dialogClassName ?? null,
        });
        setModalShow(true);
    };

    const onDownloadFile = (url) => {
        window.open(url);
    };

    const filesModalContent = files?.length > 0 && (
        <div className="tableFiles">
            <table >
                <thead>
                    <tr>
                        {HelperMetiers360.isArrayContainsValue(files, "type") && <th className="type">Type</th>}
                        {HelperMetiers360.isArrayContainsValue(files, "fileSize") && <th className="size">Taille</th>}
                        {HelperMetiers360.isArrayContainsValue(files, "hash") && <th className="hash">Hash</th>}
                        <th className="name">Nom</th>
                        {HelperMetiers360.isArrayContainsValue(files, "isPublished") && <th>Visible ?</th>}
                        <th className="downl">Télecharger</th>
                    </tr>
                </thead>
                <tbody>
                    {files
                        .sort((a, b) => a.localName?.localeCompare(b.localName))
                        .map((file, index) => (
                            <tr key={`${file.localName}${index}`}>
                                {HelperMetiers360.isArrayContainsValue(files, "type") && <td>{file.type ?? ""}</td>}
                                {HelperMetiers360.isArrayContainsValue(files, "fileSize") && <td>{HelperMetiers360.formatBytes(file.fileSize) ?? ""}</td>}
                                {HelperMetiers360.isArrayContainsValue(files, "hash") && <td>{file.hash ? file.hash : ""}</td>}
                                <td>{file.localName}</td>
                                {HelperMetiers360.isArrayContainsValue(files, "isPublished") && <td>{file.isPublished ? <i className="far fa-eye" />: ""}</td>}
                                <td>
                                    <Button
                                        variant="secondary"
                                        className="p-2 m-2"
                                        size="sm"
                                        onClick={() => onDownloadFile(file.url)}
                                    >
                                        <i className="fas fa-download" />
                                    </Button>
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>
        </div>
    );

    return (
        files ? <>
            {files?.length > 0
                ? <div className="d-flex align-items-center mb-4">
                    <strong>{modalHeaderTitle ?? "Fichiers"} : </strong>
                    <Col xs="auto">
                        <Button className="px-4 py-1 ms-2" onClick={openFileModal}>
                            {files.length}
                        </Button>
                    </Col>
                    {editFilesModal &&
                        <Col xs="auto">
                            <Button variant="secondary" size="sm" className="ms-2" onClick={editFilesModal}>
                                <i className="fas fa-edit"></i>
                            </Button>
                        </Col>
                    }
                </div>
                : editFilesModal && <Button variant="success" onClick={editFilesModal} className="mb-4">
                    <i className="fas fa-plus"></i> &nbsp;Ajouter des fichiers
                </Button>
            }
            {modalComponent}
        </> : null
    );
};
FileModalComponent.propTypes = {
    files: PropTypes.array.isRequired,
    editFilesModal: PropTypes.func,
    modalHeaderTitle: PropTypes.string,
    dialogClassName: PropTypes.string
}
export default FileModalComponent;
